<template>
  <div class="country-selector" :class="{ 'open-selector': openSelector, loading: loading }">
    <span class="mr-2">{{ $gettext('My bank is in') }}</span>
    <div class="selected-country country none-selected">
      <div v-if="availableCountries.length > 0" @click="toggleDropdown">
        <img v-if="selectedCountry.flag" :src="selectedCountry.flag" :alt="selectedCountry.name" class="selected-country-flag">
        {{ selectedCountry.name }}
        <font-awesome-icon :icon="'fa-solid fa-chevron-down'" class="selector-caret" />
      </div>
    </div>

    <div class="options-list-wrap" :style="cssVars">
      <overlay-scrollbars :options="scrollBarOptions" class="selector-scrollbar">
        <div class="options-list">

          <div v-for="country in availableCountries" :key="'country_' + country.code" @click="selectCountry(country.code)" class="country" :class="{ selected: selectedCode === country.code }">
            <div class="country-flag">
              <img v-if="country.flag" :src="country.flag" :alt="country.name">
              <div v-else class="no-logo">
                <font-awesome-icon :icon="'fa-regular fa-image-slash'" />
              </div>
            </div>
            <div class="country-name">
              <div class="country-name--descriptor">
                <span>{{ country.name }}</span>
              </div>
            </div>
          </div>

        </div>
      </overlay-scrollbars>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: 'CountrySelector',
  components: { 
  },
  props: {
    preselect: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      openSelector: false,
      selectedCode: null,
      loading: false,
      scrollBarOptions: {
        scrollbars: { 
          autoHide: "never",
          dragScrolling: true,
          clickScrolling: true,
          touchSupport: true,
          snapHandle: true
        }, 
        overflowBehavior: { y: 'scroll', x: 'scroll' },
      },
      availableCountries: [
        { name: this.$gettext('Netherlands'), code: 'NL', flag: '/static/img/flags/nl.png' },
        { name: this.$gettext('Belgium'), code: 'BE', flag: '/static/img/flags/be.png' },
        { name: this.$gettext('Spain (beta)'), code: 'ES', flag: '/static/img/flags/es.png', beta: true }
      ]
    }
  },
  computed: {
    ...mapGetters ({
      currentCompany: "main/getCurrentCompany"
    }),
    selectedCountry () {
      const selectedCountry = this.availableCountries.find(country => country.code === this.selectedCode)
      return (selectedCountry) ? selectedCountry : null
    },
    cssVars () {
      let sel_items = this.availableCountries.length
      return {
        '--sel-items': sel_items,
      }
    }
  },
  created () {
    this.setupData()
  },
  mounted () {
    document.addEventListener('click', this.close)
  },
  beforeDestroy () {
    document.removeEventListener('click',this.close)
  },
  methods: {
    setupData () {
      if (this.preselect) {
        this.selectedCode = this.preselect.code;
      }
    },
    toggleDropdown () {
      this.openSelector = !this.openSelector
    },
    selectMainCountry () {
      this.selectedCode = null
      this.openSelector = !this.openSelector
      this.$emit('change', null)
    },
    selectCountry (country_code) {
      if (this.selectedCode === country_code) return false
      this.selectedCode = country_code
      this.openSelector = !this.openSelector
      this.$emit('change', country_code)
    },
    close (e) {
      if (!this.$el.contains(e.target)) {
        this.openSelector = false
      }
    }
  }
}
</script>
<style lang="scss">
  .country-selector {
    .options-list-wrap {
      border: 1px solid transparent;
      border-radius: $radiusLg;

      .os-host { 
        height: 100% !important;
        .os-content { padding: 0 !important; }
        &.os-host-overflow-y {
          .os-content { padding-right: 0.5rem !important; }
        }
      }
    }
  }
</style>
<style lang="scss" scoped>
  .country-selector {
    position: relative;
    font-size: 18px;
    &.loading { overflow: hidden; }
    .selector-caret {
      font-size: 12px;
      color: $colorBlue;
      margin-left: 0;
    }
    .country {
      display: flex;
      align-items: center;
      border-radius: $radiusSm;
      .country-flag {
        border-radius: 100px;
        overflow: hidden;
        display: flex;
        height: 100%;
        aspect-ratio: 1;
        width: 24px;
        margin-right: 0.5rem;
        flex-shrink: 0;
        img { width: 100%; }

        background: #f2f2f2;

        display: flex;
        justify-content: center;
        align-items: center;
        .svg-inline--fa {
          font-size: 1rem;
          opacity: 0.3;
        }
        img { 
          object-fit: cover;
          width: 100%;
          height: 100%;
        }
        .no-logo {
          padding: 5px;
          text-align: center;
          line-height: 1rem;
          font-size: 14px;
        }
      }
      .country-name {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        white-space: nowrap;
        &--descriptor {
          line-height: 1;
          white-space: nowrap;
          font-size: 16px;
        }
        span { 
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .selected-country {
      height: 100%;
      cursor: pointer;
      .selected-country-flag {
        width: 20px;
        vertical-align: baseline;
      }
      &.none-selected {
        // display: flex;
        display: inline-block;
        flex-wrap: wrap;
        justify-content: space-between;
        font-size: 18px;
        color: $colorBlue;
      }
      .country-flag {
        height: 100%;
        aspect-ratio: 1;
        width: 48px;
      }
      .country-name {
        padding-right: 1.5rem;
        &--descriptor {
          font-size: 18px;
        }
      }
    }
    &.open-selector {
      .options-list-wrap {
        $baseItemHeight: 40px;
        $itemHeight: calc(#{$baseItemHeight} + 0.5rem);
        $selHeight: calc(#{$itemHeight} * var(--sel-items));
        height: calc(#{$selHeight} + 10px); // border size 10px 
        border: 1px solid rgba(0, 0, 0, 0.15);
        box-shadow: $dropdownShadow;
        z-index: 110;
      }
    }
    .options-list-wrap {
      z-index: 100;
      position: absolute;
      top: calc(100% + 0.25rem);
      right: 0;
      height: 0;
      width: 100%;
      max-height: 300px;
      max-width: 200px;
      transition: height 0.2s ease-in-out;
      overflow: hidden;
      border-radius: $radiusLg;
      background: white;
      text-align: center;
      // left: 50%;
      // transform: translateX(-50%);
      .options-list {
        padding: 0.5rem;
        width: 100%;
        .country {
          padding: 0.5rem;
          transition: all 0.2s ease;
          cursor: pointer;
          &.selected {
            opacity: 0.3;
            background-color: $colorUnassigned200;
            &:hover { background-color: $colorUnassigned200; }
          }
          &:hover {
            background: rgba(34, 172, 138, 0.07);
            color: #06926f;
          }
          &:not(:last-child) {
            margin-bottom: 0.5rem;
          }
        }
      }
      
    }
  }
</style>
